<template>
    <section class="rich-content slice-content">
        <template v-for="(contentChunk, index) of props.content" :key="index">
            <MktSliceTitle v-if="isTitle(contentChunk) && contentChunk.content" :field="contentChunk.content" />
            <PrismicRichText v-else :field="contentChunk.content" />
        </template>
    </section>
</template>

<script lang="ts" setup>
    import type {RichContentChunk} from '@nuxt-marketing-module/shared/types/RichContent';
    import {PrismicRichText} from '@prismicio/vue';
    import {MktSliceTitle} from '#components';

    type RichContentProps = {
        content: RichContentChunk[];
    };
    const props = defineProps<RichContentProps>();

    function isTitle(contentChunk: RichContentChunk): boolean {
        return contentChunk.type === 'title';
    }
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .rich-content.slice-content {
        text-align: left;
    }

    .rich-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        p,
        ol,
        ul,
        li {
            font-size: 18px;
        }

        h1,
        h2 {
            margin-bottom: var(--joy-core-spacing-8);
            font-size: var(--joy-font-size-secondary-200);
        }

        h3,
        h4,
        h5,
        h6,
        p,
        ul,
        ol {
            margin-bottom: var(--joy-core-spacing-7);
        }
        h3 {
            font-size: var(--joy-font-size-primary-800);
        }
        h4 {
            font-size: var(--joy-font-size-primary-600);
        }
        .block-img {
            display: flex;
            justify-content: center;
        }
        img {
            margin-bottom: var(--joy-core-spacing-14);
            max-width: 100%;
        }
        a {
            color: var(--joy-color-primary-50);
            text-decoration: underline var(--joy-color-primary-50);
            &:hover {
                color: var(--joy-color-primary-70);
                text-decoration: underline var(--joy-color-primary-70);
            }
        }
        div {
            width: 100%;
        }
        div[data-oembed-type='video'] {
            width: 100%;
            padding-top: 56.25%; // 16:9
            position: relative;
            iframe {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
